import $ from "jquery"

import BasePage from "pages/base_page"

class PodcastsPage extends BasePage {
  initialize(options) {
    return super.initialize(options)
  }

  changeSort() {
    const val = $("#podcast-sort").val()
    const url = `${document.location.pathname}?sort=${val}`

    return (document.location.href = url)
  }
}

PodcastsPage.prototype.events = { "change #podcast-sort": "changeSort" }

export default PodcastsPage
